import {FC} from 'react'
import {RootState} from 'setup'
import {
  selectEditOrder,
  selectIsAutoDiscountRemoved,
  selectIsProductsEditMode,
} from 'app/features/orders/redux/order/orderEditSlice'
import {Order} from 'app/features/orders/models/EditOrderState'
import {useSelector} from 'react-redux'
import {SummaryItem} from 'app/features/orders/componentsv1/shared'
import PromoDiscountAction from './PromoDiscountAction'
import WineClubDiscountAction from './WineClubDiscountAction'

type Props = {}

const Discounts: FC<Props> = () => {
  const order = useSelector<RootState, Order>(selectEditOrder)
  const isProductMode = useSelector<RootState, boolean>(selectIsProductsEditMode)
  const isDiscountRemoved = useSelector<RootState, boolean>(selectIsAutoDiscountRemoved)

  return (
    <>
      <SummaryItem
        title={<WineClubDiscountAction />}
        value={order.wineClubDiscounts}
        // isTitleBolder
        isPrimaryActive
        isDiscount
        isBetween={isProductMode}
      >
        {isDiscountRemoved && <span className='text-muted'>( Auto discount removed )</span>}
      </SummaryItem>
      <SummaryItem
        title={<PromoDiscountAction />}
        value={order.totalDiscounts}
        isPrimaryActive
        // isTitleBolder
        isDiscount
        isBetween={isProductMode}
      />
    </>
  )
}

export default Discounts
